import { Injectable } from "@angular/core";
import { CVApiService } from "../../../reusables/services/cv-api.service";
import { ScheduleAdherenceModuleData } from "./schedule-adherence.model";
import { DatePipe } from "@angular/common";

@Injectable({
    providedIn: "root",
})
export class ScheduleAdherenceService {
    constructor(
        private cvApiService: CVApiService,
        private datePipe: DatePipe
    ) {}

    async getScheduleAdherenceData(moduleKey: string, startDate: Date, isAutoRefresh: boolean = false, isFirstLoad: boolean = false) {
        try {
            const moduleRenderURL = await this.cvApiService.getModuleRenderEndPoint(moduleKey);

            const formattedDate = this.datePipe.transform(startDate, 'yyyy-MM-ddTHH:mm:ss') || '';
            const encodedDate = encodeURIComponent(formattedDate);

            const queryString = `?startDate=${encodedDate}&isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}`;
            const url = `/api/v2/dashboards/modules/scheduleAdherence/${moduleKey}${queryString}`;

            const response = await this.cvApiService.get<ScheduleAdherenceModuleData>(url, moduleRenderURL);

            if (response.status_code >= 200 && response.status_code < 300) {
                return response.data;
            } else {
                throw response;
            }
        } catch (error) {
            console.error("Failed getting schedule adherence data");
            throw error;
        }
    }
}
